/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { SampleDatasetTypes } from "../../components/dataset-ingestion-flow/connection-type/connection-type-picker/connection-type-card/connection-type-card.interfaces";
import {
    ConnectionTypes,
    SchemaResponseType,
} from "../dto/datasources.interfaces";

// enums
export enum DatasetTypes {
    OFFLINE = "offline",
    PINOT = "pinot",
    REALTIME = "realtime",
}

export enum IngestionErrorCode {
    OTHER = "OTHER",
    SCHEDULER_ERROR = "SCHEDULER_ERROR",
    TASK_GENERATOR_ERROR = "TASK_GENERATOR_ERROR",
}

export enum IngestionFormats {
    AVRO = "AVRO",
    CSV = "CSV",
    JSON = "JSON",
    ORC = "ORC",
    PARQUET = "PARQUET",
    PROTO = "PROTO",
    RESULT_SET = "RESULT_SET",
    SQL = "SQL",
    UNKNOWN = "UNKNOWN",
}

export enum HealthStatus {
    ERROR = "ERROR",
    HEALTHY = "HEALTHY",
    UNKNOWN = "UNKNOWN",
}

// types
export interface Dataset {
    configStr: string;
    datasetIngestionStatus: IngestionHealthStatus | null;
    dataSetType: string;
    dataSourceSrn: string;
    description: string;
    ingestionList: DatasetIngestion[];
    name: string;
    namespaceSrn: string;
    srn: string;
}

export interface DatasetIngestion {
    dataSourceSrn: string | null;
    format: IngestionFormats | null;
    locator: string;
    sourceSchema: SchemaResponseType | null;
    type: ConnectionTypes;
}

export interface CreateDatasetArgsType {
    configStr?: string;
    dataSetType?: string;
    dataSourceSrn?: string;
    description?: string;
    ingestionDataSourceSrn?: string;
    ingestionFormat?: string | null;
    ingestionLocator?: string;
    ingestionSourceSchema?: SchemaResponseType;
    ingestionType?: ConnectionTypes;
    name?: string;
    namespaceSrn?: string;
    sampleId?: string;
}

export interface DatasetSampleType {
    description: string;
    id: SampleDatasetTypes;
    name: string;
}

export type DatasetSamplesResponseType = DatasetSampleType[];

export interface IngestionHealthStatus {
    ingestionErrorCode: null | IngestionErrorCode;
    ingestionErrorMessage: null | string;
    lastSyncTimeMillisEpoch: null | number;
    nextFireTimeMillisEpoch: null | number;
    progressPercentage: null | number;
    status: HealthStatus;
}

export interface UpdateDatasetArgsType {
    configStr?: string;
    dataSetType?: string;
    dataSourceSrn?: string;
    description?: string;
    ingestionDataSourceSrn?: string;
    ingestionFormat?: string | null;
    ingestionLocator?: string;
    ingestionSourceSchema?: SchemaResponseType;
    ingestionType?: ConnectionTypes;
    name?: string;
    namespaceSrn?: string;
    sampleId?: string;
}
